import React, {useReducer} from "react";

import initialState from "./initial";
import reducer from "./reducer";

const Context = React.createContext(initialState);

function ContextProvider(props) {
	const [state, dispatch] = useReducer(reducer, initialState, () => ({
		...initialState,
		authKey: localStorage.getItem("auth_key") || "",
		roles: JSON.parse(localStorage.getItem("roles") || "[]"),
	}));
	return (
		<Context.Provider value={{state, dispatch}}>
			{props.children}
		</Context.Provider>
	);
}

export {Context, ContextProvider}